import api from './api';

// Cache for settings to avoid repeated API calls
let companySettingsCache = null;
let systemControlsCache = null;
let cacheTimestamp = 0;
const CACHE_TTL = 5 * 60 * 1000; // 5 minutes

const isCacheValid = () => Date.now() - cacheTimestamp < CACHE_TTL;

export const getCompanySettings = async () => {
  if (companySettingsCache && isCacheValid()) return companySettingsCache;
  try {
    const res = await api.get('/settings/company');
    companySettingsCache = res.data;
    cacheTimestamp = Date.now();
    return companySettingsCache;
  } catch {
    return {
      company_name: 'Jai Matadi Grey Order Management',
      address: 'Textile Manufacturing Division',
      phone: '',
      email: '',
      logo_url: null,
      print_header: 'Jai Matadi Grey Order Management',
      print_footer: ''
    };
  }
};

export const getSystemControls = async () => {
  if (systemControlsCache && isCacheValid()) return systemControlsCache;
  try {
    const res = await api.get('/settings/system-controls');
    systemControlsCache = res.data;
    cacheTimestamp = Date.now();
    return systemControlsCache;
  } catch {
    return {
      enable_whatsapp: true,
      enable_pdf_export: true,
      enable_audit_logs: true,
      enable_validation_alerts: true,
      enable_notifications: true
    };
  }
};

export const getPdfSettings = async (module) => {
  try {
    const res = await api.get(`/settings/pdf/${module}`);
    return res.data;
  } catch {
    return {
      module,
      show_header: true,
      show_footer: true,
      show_logo: true,
      header_text: 'Jai Matadi Grey Order Management',
      footer_text: '',
      visible_fields: [],
      show_signature: false,
      signature_labels: []
    };
  }
};

// Clear cache (call after settings are updated in admin panel)
export const clearSettingsCache = () => {
  companySettingsCache = null;
  systemControlsCache = null;
  cacheTimestamp = 0;
};
